function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#5B5B5B;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.3,218.2H19c0.1-0.1,0.2-0.3,0.3-0.4V218.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 128.1,
  className: "st0",
  width: 46.4,
  height: 179.8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M205.6,307.9h-40.4V186.3L149,307.9h-29L102.8,189v118.9H62V128.1h60.2c4.6,27.9,8.4,56.1,12.2,84.3l10.7-84.3 h60.5V307.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M221.7,307.8V128h34.6c24.8,0,62.9-2.3,68.9,29.4c2.4,10.7,2,22.9,2,34.3C327.2,316.2,342.8,307.9,221.7,307.8 L221.7,307.8z M282.7,181.4c0-13.6,2.3-22.5-14.5-22.5v117.7c17.2,0.4,14.5-12.2,14.5-25.9V181.4z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M448,265.6c0,22.1-3.4,43.5-31.2,43.5c-12.7,0-21.4-4.2-29.4-13.8l-2.7,11.4h-41.9V126.9h44.6v58.7 c8.4-9.1,16.9-12.9,29.4-12.9c30.1,0,31.2,18,31.2,42.3L448,265.6z M403,216.9c0-7.6,1.5-17.9-8.7-17.9c-8.4,0-6.9,12.5-6.9,17.9 c0,0.8-1.5,55.7,1.5,62.9c1.1,2.3,3.1,3.4,5.3,3.4c11,0,8.7-12.7,8.7-20.3V216.9z"
});

var SvgImdb = function SvgImdb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImdb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imdb.6476f6da.svg";
export { ForwardRef as ReactComponent };